<template>
  <div class="receptionOverflow" style="display: flex;justify-content: center;align-items: center;">
    <div v-loading="loading" class="printLeft">
      <h1>{{ getShopName() }}</h1>
      <h2>消费小票</h2>
      <div class="rlli">
        <p>订单编号：{{ receiptList.beautyOrderInfo.orderNumber || '--' }}</p>
        <p v-show="receiptList.beautyOrderInfo.customerPhoneNumber">顾客手机：{{ receiptList.beautyOrderInfo.customerPhoneNumber }}</p>
        <p v-show="orderType != 2">顾客姓名：{{ receiptList.beautyOrderInfo.customerName || '新增顾客' }}</p>
        <p>下单时间：{{ receiptList.beautyOrderInfo.orderTime || '--' }}</p>
        <p>付款时间：{{ receiptList.beautyOrderInfo.settleAccountsTime || '--' }}</p>
        <div v-show="receiptList.beautyOrderInfo.notes" class="newr"><span>订单备注：</span><samp>{{ receiptList.beautyOrderInfo.notes }}</samp></div>
      </div>
      <div v-if="receiptList.beautyServiceInfoList||receiptList.giftInfoList ? receiptList.beautyServiceInfoList.length > 0||receiptList.giftInfoList.length>0 ? true : false : false" class="rlli">
        <h2>消费明细</h2>
        <h3 v-if="receiptList.beautyServiceInfoList.length>0">
          <span>服务/产品/套餐</span>
          <samp>数量</samp>
          <label>小计</label>
        </h3>
        <h4 v-for="(v,n) in receiptList.beautyServiceInfoList" :key="n">
          <span>{{ v.serviceProject }}</span>
          <samp>{{ v.number }}</samp>
          <label>{{ v.subtotalPrice }}</label>
        </h4>
        <h3 v-if="receiptList.giftInfoList.length>0">
          <span>赠</span>
        </h3>
        <h3 v-if="receiptList.giftInfoList.length>0">
          <span>服务/产品/套餐</span>
          <samp>数量</samp>
          <label>小计</label>
        </h3>
        <h4 v-for="(v,n) in receiptList.giftInfoList" :key="n">
          <span>{{ v.serviceProject }}</span>
          <samp>{{ v.number }}</samp>
          <label>{{ v.subtotalPrice }}</label>
        </h4>
      </div>
      <div class="rlli">
        <p>合计：{{ receiptList.consumptionTotal }}</p>
      </div>
      <div v-if="receiptList.beautyDeductInfoList||receiptList.giftDeductProjectInfos ? receiptList.beautyDeductInfoList.length > 0 ||receiptList.giftDeductProjectInfos.length > 0? true : false : false" class="rlli">
        <h2>划扣明细</h2>
        <div v-for="(v,n) in receiptList.beautyDeductInfoList" :key="n" class="newp">
          <div class="pname">{{ v.deductCombo }}</div>
          <div v-for="(a,b) in v.deductProjectInfos" :key="b" class="iname">
            <span>{{ a.deductProject }}</span>
            <samp>（{{ a.deductNum }}）</samp>
          </div>
        </div>
        <!--6.1新增-->
        <div v-if="receiptList.giftDeductProjectInfos.length>0" class="newp">
          <div class="pname">赠品划扣</div>
          <div v-for="(a,b) in receiptList.giftDeductProjectInfos" :key="b" class="iname">
            <span>{{ a.deductProject }}</span>
            <samp>（{{ a.deductNum }}）</samp>
          </div>
        </div>
      </div>
      <div class="rlli">
        <h2>付款明细</h2>
        <p v-show="receiptList.beautyPaymentInfo.total">消费总额：{{ receiptList.beautyPaymentInfo.total }}</p>
        <p v-show="receiptList.beautyPaymentInfo.totalDiscount">优惠金额：{{ receiptList.beautyPaymentInfo.totalDiscount }}</p>
        <p v-show="receiptList.beautyPaymentInfo.deductionAmount">划扣金额：{{ receiptList.beautyPaymentInfo.deductionAmount }}</p>
        <p v-show="receiptList.beautyPaymentInfo.deposit">已付定金：{{ receiptList.beautyPaymentInfo.deposit }}</p>
        <p v-show="receiptList.beautyPaymentInfo.receivable">应付金额：{{ receiptList.beautyPaymentInfo.receivable }}</p>
      </div>

      <div v-if="receiptList.beautyCostInfo" class="rlli">
        <h5 v-show="receiptList.beautyCostInfo.amountPaid">实付金额：{{ receiptList.beautyCostInfo.amountPaid }}</h5>
        <p v-show="receiptList.beautyCostInfo.payType">付款方式：{{ receiptList.beautyCostInfo.payType }}</p>
        <!-- <p v-show="receiptList.beautyCostInfo.integral">剩余积分：{{ printData.integral }}</p>
        <p v-show="receiptList.beautyCostInfo.fansGold">剩余粉币：{{ printData.fansGold }}</p> -->
        <!-- <p v-show="printData.returnAmount">找零：￥{{(printData.returnAmount*1).toFixed(2)}}</p> -->
        <!-- <p v-show="printData.remark" style="height: auto;line-height: 18px;padding: 4px 0;">订单备注：{{printData.remark}}</p> -->
      </div>

      <div v-if="receiptList.contactNumber || receiptList.shopAddress" class="rlli">
        <p v-show="receiptList.contactNumber">服务电话：{{ receiptList.contactNumber }}</p>
        <p v-show="receiptList.shopAddress" style="height: auto;line-height: 18px;padding: 4px 0;">地址：{{ receiptList.shopAddress }}</p>
      </div>
      <div v-if="printData.publicUrl" class="rlli" style="display: flex;">
        <!-- <div class="liimg" v-show="printData.appletUrl">
          <img :src="printData.appletUrl" />
          <h6>小程序</h6>
        </div> -->
        <div v-show="printData.publicUrl" class="liimg">
          <img :src="printData.publicUrl+'?x-oss-process=image/resize,m_lfit,w_200,h_200'" />
          <h6>公众号</h6>
        </div>
      </div>
      <div class="rlli">
        <h1>欢迎再次光临</h1>
        <p style="text-align: center;">请妥善保管此凭证</p>
        <p style="text-align: center;">技术支持 · 多粉</p>
      </div>
    </div>
    <div class="printRight">
      <div class="info">
        <h1>
          <i class="el-icon-circle-check"></i>
        </h1>
        <p class="theme-red">￥{{ orderPrice }}</p>
        <h6>收款完成</h6>
        <h5 v-if="ishd===0||isDesktop==0">
          <i :class="refreshStatus ? 'el-icon-loading' : 'el-icon-refresh'" @click="getPrinterList"></i>
          <span>当前打印机设备号：</span>
          <el-dropdown v-if="printerId || printerName" trigger="click" @command="choosePrinter">
            <span class="el-dropdown-link">
              {{ printerName }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu v-if="printerList ? printerList.length > 0 ? true : false : false" slot="dropdown" size="medium" @click="choosePrinter">
              <el-dropdown-item v-for="(v,n) in printerList" :key="n" :command="v.id+','+v.printerName" :disabled="v.printerState == 0 ? true : false">{{ v.printerName }}{{ v.printerState == 0 ? '（不在线）' : '' }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <label v-else>
            <span class="theme-red">未连接</span>
            <span class="theme-blue" @click="jumpSetPrinter">前往设置</span>
          </label>
        </h5>
        <h4 v-if="printerId">
          <span @click="printOrder('',1)">打印小票</span>
        </h4>
        <h3>
          <el-button class="span" type="primary" @click="backPackage">返回套餐</el-button>
          <el-button class="span" @click="backReception">返回前台</el-button>
          <!-- <span @click="continueOrder">返回</span> -->
          <!-- <span @click="backPackage">返回套餐</span>
          <samp @click="backReception">返回前台</samp> -->
        </h3>
      </div>
    </div>
    <drawer v-if="showDisplay" title="划扣剩余信息" :display.sync="showDisplay" class="printInfo">
      <ul v-for="(item,index) in deductInfo.deductInfoList" :key="index">
        <li>
          <h1>{{ item.name }}</h1>
          <h2>到期时间：{{ item.efficientTime }}</h2>
          <div class="line">
            <i class="iconfont icon-yuding1"></i>
            <span> 剩余信息</span>
            <div class="item">
              <p v-for="(i,b) in item.detailList" :key="b">{{ i.name }}<span class="fontColor">（{{ item.countLimitType===2?'无限次数':'剩'+i.count+'次' }}）;</span></p>
            </div>
          </div>
        </li>
      </ul>
    </drawer>
  </div>
</template>

<script>
import {
  printOrder, getPrintSetList, getOrderDetail4AllDto, getPrinterOrderCenter, getPackageDeductInfo
} from './api/index';
import drawer from '../../../publicVue/drawer';

export default {
  components: {
    drawer
  },
  data() {
    return {
      orderPrice: '',
      orderType: '',
      orderId: '',
      printerList: [], // 打印机列表
      printerId: '', // 打印机ID
      printerName: '', // 打印机名称
      refreshStatus: false, // 刷新状态
      printData: {}, // 打印预览的数据
      deductList: [], // 套餐划扣明细
      isDesktop: this.$isDesktop() === true ? 1 : 0, // 判断是否是客户端 0不是  1是-5.7添加
      ishd: window.sessionStorage.ishd ? 1 : 0, // 判断是否是HD  0不是  1是-5.7添加
      loading: true, // 5.7添加
      showDisplay: true, // 是否展示划扣剩余信息
      deductInfo: [], // 6.1划扣信息
      receiptList: {
        beautyOrderInfo: {},
        beautyServiceInfoList: [],
        giftInfoList: [],
        beautyPaymentInfo: {},
      }, // 小票数据
      customerPhone: '',
    };
  },
  activated() {
    this.orderPrice = window.sessionStorage.successResulteMoney;
    this.orderId = window.sessionStorage.successOrderId;
    this.orderType = window.sessionStorage.successOrderType;
    this.getDeductList();
    this.getPrinterList();
    this.getPrintData();
    this.initGetPackageDeductInfo();
  },
  methods: {
    // 获取门店名称
    getShopName() {
      const arr = JSON.parse(window.sessionStorage.storeList);
      let name = '';
      arr.forEach((a) => {
        if (a.id == window.sessionStorage.shopId) {
          name = a.shopName;
        }
      });
      return name;
    },
    // 选择打印机
    choosePrinter(val) {
      this.printerId = val.split(',')[0];
      this.printerName = val.split(',')[1];
    },
    // 获取打印机列表
    getPrinterList() {
      this.refreshStatus = true;
      const data = {
        printType: this.orderType == 2 ? 31 : 30
      };
      getPrintSetList(data).then((res) => {
        if (res && res.code == 0) {
          this.refreshStatus = false;
          this.printerList = res.data;
          let pNum = 'null';
          if (res.data.length > 0) {
            let arr = '';
            res.data ? '' : res.data = [];
            res.data.forEach((v, n) => {
              if (v.printerState == 1) {
                pNum = pNum == 'null' ? n : n > pNum ? pNum : n;
                arr = arr + v.id + (res.data.length == (n + 1) ? '' : ',');
              }
            });
            if (pNum == 'null') {
              this.printerId = '';
              this.printerName = '暂无可用设备';
            } else {
              this.printerId = res.data[pNum].id;
              this.printerName = res.data[pNum].printerName;
            }
            if (arr && window.sessionStorage.printOrderStatus == 1) {
              this.printOrder(arr);
              window.sessionStorage.printOrderStatus = 2;
            }
          }
        } else {
          this.refreshStatus = true;
        }
      });
    },
    // 打印小票
    printOrder(val, num) {
      const data = {
        orderId: this.orderId,
        mainId: window.sessionStorage.mainId,
        printType: this.orderType, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
        printId: val || this.printerId,
        isManual: num ? 1 : 0
      };
      printOrder(data).then((res) => {
        if (res.code == 0) {
          if (val) return;
          this.$message({
            message: res.msg,
            type: 'success',
            duration: 2000
          });
        }
      });
    },
    // 获取套餐划扣明细
    getDeductList() {
      const data = {
        orderId: this.orderId,
        mainId: window.sessionStorage.mainId,
        printType: this.orderType, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣
      };
      getPrinterOrderCenter(data).then((res) => {
        if (res.code == 0) {
          this.receiptList = res.data;
          this.deductList = res.data.beautyDeductInfoList;
        }
      });
    },
    // 返回套餐
    backPackage() {
      if (this.Lib.checkPower('beauty-2-ckgkxq2') == false) return;
      window.sessionStorage.customerPhone = this.customerPhone;
      this.$router.push({
        name: 'customer-info',
        params: {
          name: 'customer-package'
        }
      });
    },
    // 返回前台
    backReception() {
      this.$router.push({
        name: 'stage-index'
      });
    },
    // 继续开单
    continueOrder() {
      if (!JSON.parse(sessionStorage.getItem('menusList')).find((data) => data.iDenTi === 'beauty-2-fwkd') && this.orderType == 1) {
        this.$message({ type: 'warning', message: '暂无权限，请联系管理员分配权限' });
        return;
      }
      if (!JSON.parse(sessionStorage.getItem('menusList')).find((data) => data.iDenTi === 'beauty-2-tcbl') && this.orderType == 4) {
        this.$message({ type: 'warning', message: '暂无权限，请联系管理员分配权限' });
        return;
      }
      let name = '';
      switch (this.orderType) {
        case '1':
          name = 'stage-serviceBilling';
          break;
        case '2':
          name = 'stage-quickCashier';
          break;
        case '3':
          // service-index 还款跳到订单页
          name = 'service-index';
          break;
        default:
          name = 'stage-setMeal';
          break;
      }
      this.$router.push({
        name
      });
    },
    // 前往后台设置打印机
    jumpSetPrinter() {
      window.open(window.sessionStorage.setUrl4Print);
    },
    getPrintData() {
      this.loading = true;
      const data = {
        id: this.orderId,
        orderType: this.orderType
      };
      getOrderDetail4AllDto(data).then((res) => {
        if (res.code == 0) {
          res.data.itemList ? '' : res.data.itemList = [];
          this.customerPhone = res.data.phone;
          res.data.phone ? res.data.phone = res.data.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '';
          this.printData = res.data;
          this.loading = false;
        } else {
          console.log(res);
        }
      });
    },

    // 获取套餐划扣明细
    initGetPackageDeductInfo() {
      const data = {
        orderId: this.orderId,
        mainId: window.sessionStorage.mainId,
        orderType: this.orderType, // 1：服务订单，2:快捷收银订单，3：美容套餐购买/充值，4：美容套餐划扣  订单类型( 1/7 ：服务/预约 订单 4：直接划扣订单)
      };
      getPackageDeductInfo(data).then((res) => {
        if (res.code == 0) {
          if (res.data) {
            this.deductInfo = res.data;
            this.showDisplay = this.deductInfo.deductInfoList.length > 0;
          } else {
            this.showDisplay = false;
          }
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>
.printLeft {
  padding: 10px;
  width: 280px;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  overflow-x: hidden;
  overflow-y: auto;
  .rlli {
    border-top: 1px dotted #999;
    padding: 10px 0;
    .liimg {
      width: 120px;
      height: 150px;
      margin: auto;
      display: block;
      img {
        display: block;
        width: 120px;
        height: 120px;
      }
      h6 {
        width: 120px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-align: center;
      }
    }
    .liimg:first-child {
      padding-right: 14px;
    }
    .liimg:last-child {
      padding-left: 15px;
    }
    .lip {
      height: 14px;
      line-height: 14px;
      font-size: 14px;
      width: 130px;
      padding-right: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      clear: both;
    }
    .newp {
      clear: both;
      .pname {
        // font-size: 16px;
        font-size: 12px;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #333;
        font-weight: bold;
      }
      .iname {
        font-size: 12px;
        line-height: 16px;
      }
    }
    .newr {
      display: flex;
      font-size: 12px;
      line-height: 16px;
      padding: 5px 0;
      span {
        width: 60px;
      }
      samp {
        flex: 1;
        word-break: break-all;
      }
    }
  }
  h1 {
    font-size: 20px;
    text-align: center;
    color: #000;
    line-height: 20px;
    margin-top: 15px;
  }
  h2 {
    height: 16px;
    line-height: 16px;
    margin: 15px 0;
    font-size: 16px;
    text-align: center;
    color: #000;
  }
  h3 {
    font-size: 12px;
    font-weight: bold;
    display: flex;
    height: 40px;
    line-height: 40px;
    span {
      font-weight: bold;
      float: left;
      width: 130px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    samp {
      font-weight: bold;
      width: 50px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    label {
      font-weight: bold;
      width: 70px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  h4 {
    font-size: 12px;
    display: flex;
    height: 30px;
    line-height: 30px;
    span {
      float: left;
      width: 130px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    samp {
      width: 50px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    label {
      width: 70px;
      padding-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  h5 {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    height: 32px;
    line-height: 32px;
  }
  p {
    font-size: 12px;
    height: 26px;
    line-height: 26px;
  }
}
.printRight {
  flex: 1;
  .info {
    height: auto;
    display: block;
    margin: auto;
    h1 {
      height: 90px;
      line-height: 90px;
      text-align: center;
      i {
        font-size: 90px;
        color: #67c23a;
      }
    }
    p {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      text-align: center;
    }
    h6 {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #999;
      text-align: center;
      padding-bottom: 15px;
    }
    h5 {
      text-align: center;
    }
    h4 {
      text-align: center;
      margin: 20px auto;
      span {
        display: block;
        margin: 0 auto;
        width: 250px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        color: #333;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #d8dce5;
        cursor: pointer;
      }
    }
    h3 {
      text-align: center;
      margin: 20px auto;
      .span {
        display: block;
        margin: 0 auto 10px auto;
        width: 250px;
      }
    }
  }
}

/*6.7剩余信息 */
.printInfo{
   ul{
    width: 100%;
    overflow: hidden;
    li:last-child{
      border-bottom:none;
    }
    li{
      background: #FFFFFF;
      border-bottom: 1px solid #D8DCE5;
      h1{
        font-size: 16px;
        color: #333333;
        font-weight: bold;
      }
      h2{
        font-size: 16px;
        color: #666666;
        padding: 12px 0;
      }
      .line{
        font-size: 16px;
        color: #333333;
        // font-weight: bold;
        i{
          font-size: 17px;
          color: #FCAF49;
          // margin-right: 5px;
        }
        span{
          //  font-weight: bold;
        }
       .item{
        width: 100%;
        color: #666666;
        padding: 12px 0;
        span{
          // font-weight:normal;
        }
       }
      }
      .fontColor{
        color:#FD5C8CFF;
      }
    }
  }
}
</style>
<style scoped>
.printLeft {
  height: calc(100vh - 90px);
}
.printLeft::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}

.printLeft::-webkit-scrollbar-track-piece {
  background-color: #fff;
}

.printLeft::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.printLeft::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #999;
}
</style>
